import React, { useState, useEffect } from 'react';
import vulnApi from '../../services/vulnApi';

function VulnFilterBar({
  customerId,
  assetGroupId,
  onCustomerChange,
  onAssetGroupChange,
  children,
}) {
  const [customers, setCustomers] = useState([]);
  const [assetGroups, setAssetGroups] = useState([]);

  useEffect(() => {
    vulnApi.getCustomers().then((data) => {
      setCustomers(Array.isArray(data) ? data : []);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (!customerId) {
      setAssetGroups([]);
      return;
    }
    vulnApi.getAssetGroups(customerId).then((data) => {
      setAssetGroups(Array.isArray(data) ? data : []);
    }).catch(() => setAssetGroups([]));
  }, [customerId]);

  return (
    <div className="flex items-center flex-wrap gap-2">
      <select
        value={customerId}
        onChange={(e) => onCustomerChange(e.target.value ? Number(e.target.value) : '')}
        className="text-sm text-slate-600 dark:text-slate-300 bg-transparent border-0 border-b border-slate-300 dark:border-slate-600 focus:border-indigo-500 focus:ring-0 py-1 pr-8 pl-1 cursor-pointer appearance-none"
        style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E")`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 4px center' }}
      >
        <option value="">All Customers</option>
        {customers.map((c) => (
          <option key={c.id} value={c.id}>{c.name}</option>
        ))}
      </select>

      {customerId && assetGroups.length > 0 && onAssetGroupChange && (
        <select
          value={assetGroupId}
          onChange={(e) => onAssetGroupChange(e.target.value)}
          className="text-sm text-slate-600 dark:text-slate-300 bg-transparent border-0 border-b border-slate-300 dark:border-slate-600 focus:border-indigo-500 focus:ring-0 py-1 pr-8 pl-1 cursor-pointer appearance-none"
          style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E")`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 4px center' }}
        >
          <option value="">All Groups</option>
          {assetGroups.map((g) => (
            <option key={g.id} value={g.id}>{g.name}</option>
          ))}
        </select>
      )}

      {children}
    </div>
  );
}

export default VulnFilterBar;
